// Repeating "© Hope & Favor" watermark overlay + image-theft deterrents for product media.
const WM_SVG = encodeURIComponent(
  "<svg xmlns='http://www.w3.org/2000/svg' width='260' height='150'>" +
    "<text x='18' y='85' transform='rotate(-26 130 75)' font-family='Georgia, \"Times New Roman\", serif' font-size='19' fill='#ffffff'>\u00A9 Hope &amp; Favor</text>" +
  "</svg>"
);

const WM_STYLE = {
  backgroundImage: `url("data:image/svg+xml;charset=utf-8,${WM_SVG}")`,
  backgroundRepeat: "repeat",
  opacity: 0.15,
  mixBlendMode: "overlay",
};

// Watermark layer — sits above the image, never blocks interaction.
export const WatermarkOverlay = ({ className = "" }) => (
  <div aria-hidden className={`absolute inset-0 pointer-events-none select-none ${className}`} style={WM_STYLE} />
);

// Spread onto <img> product media to deter right-click "Save Image As" and dragging.
const block = (e) => e.preventDefault();
export const noSave = { draggable: false, onContextMenu: block, onDragStart: block };

// Copyright-prepended, brand-tagged alt text for product images.
export const productAlt = (p = {}) => {
  const year = new Date().getFullYear();
  const name = p.name || "";
  const desc = p.short_desc || "";
  const detail = [name, desc].filter(Boolean).join(" — ");
  return `Copyright \u00A9 ${year} Hope & Favor — Original Hope & Favor Handcrafted Floral Resin Box Design${detail ? " — " + detail : ""}`;
};
